import React, { useContext, useRef, useState } from "react";
import { toast } from "react-toastify";
import api from "../../api";
import { AuthContext } from "../../context/AuthContext";
import { LoaderContext } from "../../context/LoaderContext";
import { useOnClickOutside } from "../../helper/hooks";
import { isMobile } from "../../utils/globals";
import { StyledBurger, StyledHeader, StyledMobileHeader } from "./styled";
import { MdLogout, MdModeEditOutline } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { goToPricing } from "../../helper/functions";

interface HeaderProps {
  title: string;
}

const Header: React.FC<HeaderProps> = ({ title }) => {
  const { user, isAuthenticated, removeToken, setIsAuthenticated } =
    useContext(AuthContext);
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  const { showLoader } = useContext(LoaderContext);

  const toggleOptions = () => {
    if (document.getElementById("dropdown")) {
      document.getElementById("dropdown")!.style.display =
        document.getElementById("dropdown")!.style.display === "block"
          ? "none"
          : "block";
    }
  };

  useOnClickOutside<HTMLDivElement>(ref, (_) => {
    if (isMobile) {
      return;
    }
    document.getElementById("dropdown")!.style.display = "none";
  });

  const handleLogout = async () => {
    showLoader({
      show: true,
    });
    setOpen(false);
    api
      .Logout()
      .then((res) => {
        if (res.status === 200) {
          toast.success(res.data.message);
          removeToken();
          setIsAuthenticated(false);
        }
      })
      .catch((err) => {
        toast.error(err.response?.data?.message || "Something went wrong");
      })
      .finally(() => {
        showLoader({
          show: false,
        });
      });
  };
  return (
    <>
      <StyledMobileHeader id="mobile-header" open={open}>
        <StyledBurger open={open} onClick={() => setOpen(!open)}>
          <div />
          <div />
          <div />
        </StyledBurger>
        <ul>
          <li>
            <a href="/" className="title brandname">
              {title}
            </a>
          </li>
        </ul>
      </StyledMobileHeader>

      <StyledHeader open={open} id="main-header">
        <div className="header-sub-cont">
          <ul>
            <li>
              <a href="/" className="title brandname">
                {title}
              </a>
            </li>
          </ul>
          <ul>
            {isAuthenticated && (
              <>
                <li>
                  <a href="/dashboard" onClick={() => setOpen(false)}>
                    Dashboard
                  </a>
                </li>
              </>
            )}
            <li>
              <a href="/generate/qr" onClick={() => setOpen(false)}>
                Generate QR
              </a>
            </li>
            <li>
              {/* eslint-disable-next-line */}
              <a
                // href="/generate/url"
                onClick={() => {
                  if (!isAuthenticated) {
                    toast.info("Log in or Register to generate a short url");
                  }
                  navigate("/generate/url");
                  setOpen(false);
                }}
              >
                Generate short url
              </a>
            </li>
          </ul>
          <ul>
            <li>
              {/* eslint-disable-next-line */}
              <a
                onClick={() => {
                  setOpen(false);
                  goToPricing();
                }}
              >
                Pricing
              </a>
            </li>
            {!isAuthenticated ? (
              <>
                <li>
                  <a href="/login" onClick={() => setOpen(false)}>
                    Login
                  </a>
                </li>
                <li>
                  <a href="/register" onClick={() => setOpen(false)}>
                    Register
                  </a>
                </li>
              </>
            ) : (
              <>
                <li
                  className="user-name"
                  style={{
                    marginRight: "15px",
                  }}
                  onClick={() => {
                    toggleOptions();
                  }}
                >
                  {user?.name} <span></span>
                  <div ref={ref} className="dropdown-content" id="dropdown">
                    <p
                      onClick={() => {
                        navigate("/profile");
                        setOpen(false);
                      }}
                    >
                      <MdModeEditOutline />
                      My profile
                    </p>
                    <p onClick={handleLogout}>
                      <MdLogout />
                      Logout
                    </p>
                  </div>
                </li>
              </>
            )}
          </ul>
        </div>
      </StyledHeader>
    </>
  );
};

export default Header;
